import React from 'react';
import AdminReviewCardAddModForm from '../../../components/admin/reviewCard/AdminReviewCardAddModForm';

const AdminReviewCardAddMod = () => {
  return (
    <div className='w-full h-full flex items-center justify-center'>
      <AdminReviewCardAddModForm />
    </div>
  );
};

export default AdminReviewCardAddMod;
